<template>
  <v-row>
    <DataTable
        class="elevation-0 w-100 gridTable"
        :class="{'no-header-borders': noHeaderBorders}"
        loading-text="Загрузка данных..."
        no-data-text="Нет данных"
        v-bind.sync="tableModel.bind"
        v-on="tableModel.on"
        :page.sync="tableModel.bind.options.page"
    >

      <template v-slot:header="{ props }"></template>

      <template #bottom></template>

      <template v-slot:item="{ item }">
        <tr>
          <template v-for="(key, index) in keysTableModel.filter(k => k !== 'actions')" :key="index">
            <td :class="'column' + (index + 1)">
              <slot name="item.c.status" v-bind="{ value: item.c.status }" v-if="key === 'c.status'"></slot>
              <slot name="item.u.username" v-bind="{ item: item.u }" v-else-if="key === 'u.username'"></slot>
              <span v-else>{{ getNestedValue(item, key) }}</span>
            </td>
          </template>
          <td :class="'column' + keysTableModel.length + 1">
            <v-menu transition="slide-x-transition"
                    location="bottom left"
                    :open-on-hover="true"
                    :close-on-content-click="false"
            >
              <template v-slot:activator="{ props }">
                <div class="actionsGrid">
                  <v-btn
                      class="px-0 action-button-color"
                      icon="custom:editItemIcon"
                      variant="text"
                      @click="edit(getNestedValue(item, subject))"
                  />
                  <v-btn
                      v-if="subject === 'u' && (!item.u.isAdmin && item.u.id != user.opts.id)"
                      variant="text"
                      icon="mdi-close"
                      color="rgb(182, 1, 1)"
                      @click="removeUser(item.u)"
                  >
                  </v-btn>
                  <v-btn
                      v-if="subject !== 'config'"
                      class="px-0 action-button-color"
                      icon="custom:eyeOutlineIcon"
                      variant="text"
                      @click="view(getNestedValue(item, subject))"
                  />
                  <v-btn
                    v-if="subject === 'c'"
                    class="px-0 action-button-color"
                    icon="custom:staffIcon"
                    variant="text"
                    @click="viewStaffs(item)"
                  />
                  <div v-if="subject === 'c'">
                    <v-btn
                      v-if="item.c.status === CONTRAGENT_STATUSES.REGISTERED.code"
                      variant="text"
                      icon="mdi-cancel"
                      color="rgb(var(--data-table-font-header-color))"
                      class="px-0"
                      @click="switchStatus(item.c, 'blocked')"
                    />
                    <v-btn
                      v-if="item.c.status === CONTRAGENT_STATUSES.BLOCKED.code"
                      variant="text"
                      icon="mdi-play-circle-outline"
                      color="rgb(var(--data-table-font-header-color))"
                      class="px-0"
                      @click="switchStatus(item.c, 'unblocked')"
                    />
                  </div>
                  <div v-if="subject === 'u' && item.u.id !== currentUser.id">
                    <v-btn
                      v-if="item.u.status === USER_STATUSES.AUTHORIZED.code"
                      variant="text"
                      icon="mdi-cancel"
                      color="rgb(var(--data-table-font-header-color))"
                      class="px-0"
                      @click="switchStatus(item, 'blocked')"
                    />
                    <v-btn
                      v-if="item.u.status === USER_STATUSES.BLOCKED.code"
                      variant="text"
                      icon="mdi-play-circle-outline"
                      color="rgb(var(--data-table-font-header-color))"
                      class="px-0"
                      @click="switchStatus(item, 'unblocked')"
                    />
                  </div>
                </div>
              </template>
            </v-menu>
          </td>
        </tr>
      </template>
    </DataTable>
  </v-row>
  <Pagination
    :page-sizes-list="pageSizes"
    :table-model="tableModel"
  />

  <ConfirmDialog ref="confirm" />
</template>

<script>
import api from '@/api';
import { toast } from '@/lib/toast';
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import { CONTRAGENT_STATUSES, USER_STATUSES } from '@/lib/statusHelper';
import Config from '@/config';
import Pagination from '@/components/Pagination.vue';
import DataTable from '@intec/vue-components/table/DataTable.vue'

export default {
  name: 'adminDataTable',
  components: { ConfirmDialog, Pagination, DataTable },
  props: {
    tableModel: {
      Object,
      required: true,
    },
    keysTableModel: {
      Array,
      required: true,
    },
    subject: {
      String,
      required: true,
    },
    edit: {
      Function,
      required: true,
    },
    view: {
      Function,
      required: true,
    },
    viewStaffs: {
      Function
    },
    switchStatus: {
      Function,
      required: true
    },
    noHeaderBorders: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const currentUser = Config.getUser().opts;
    return {
      pageSizes: [
        { title: '10', value: 10 },
        { title: '25', value: 25 },
        { title: '50', value: 50 },
        { title: '100', value: 100 },
      ],
      currentUser,
      CONTRAGENT_STATUSES,
      USER_STATUSES,
      user: Config.getUser()
    }
  },
  methods: {
    getNestedValue(obj, path) {
      return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''), obj);
    },
    async removeUser(user) {
      const { id, fio } = user;

      let application = await this.$refs.confirm.open(
        'Удаление пользователя',
        this.$t(`Вы действительно хотите удалить пользователя "{_1}"?`, {'_1': fio}),
      );
      if (application) {
        try {   
          await api.delete(`/admin/users/${id}/remove`);
          this.tableModel.reload();
        } catch (e) {
          toast.error(e.message);
        }
      }
    }
  },
}
</script>

<style scoped lang="scss">
.actionsGrid {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(4, 1fr);
  width: 20px;

  .v-btn {
    width:24px;
    min-width: 20px;
    margin: 0 4px;
  }
}

.action-button-color {
  color: rgb(var(--data-table-font-header-color));
}
</style>